const TAX_ID_WARNING_KEYWORDS = ['company tax id', 'tax id', 'tax provider needs additional account details'];

export const filterTaxIdWarning = (warning?: string | null): string | null => {
    if (!warning) {
        return null;
    }

    const normalized = warning.toLowerCase();
    const containsTaxIdKeyword = TAX_ID_WARNING_KEYWORDS.some((keyword) =>
        normalized.includes(keyword)
    );

    return containsTaxIdKeyword ? null : warning;
};
